@use "../../design-tokens/border-radius/border-radius" as *;
@use "../../design-tokens/typography/typography" as *;

@layer design-system {
  .chartWrapper {
    height: 210px;
  }

  .root {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    gap: 0;
  }

  .legendWrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 4px 8px;
    cursor: default;

    &:hover {
      background-color: var(--surface-hover);
      border-radius: 8px;
    }
  }

  .rowActive {
    background-color: var(--surface-hover);
    border-radius: 8px;
  }

  .legendNameWrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
  }

  .bodySmallText {
    @include typography-v2-body-sm;
    color: var(--text-default);
  }

  .styledDot {
    width: 12px;
    height: 12px;
    border-radius: border-radius(full);
  }
}
